import React from 'react';
import ClientInactiveDialog from './ClientInactiveDialog';
import DeleteUserDialog from './DeleteUserDialog';
import CustomDeleteConfirmationModal from '../../../CustomDeleteConfirmationModal/CustomDeleteConfirmationModal';

const ModalsSection = ({
  // Client Inactive Dialog
  openDialog,
  handleCloseDialog,
  handleActivateClient,

  // Delete User Dialog
  openDeleteDialog,
  handleCloseDeleteDialog,
  handleDeletePermanently,
  handleInactiveUser,

  // Custom Delete Confirmation Modal
  isModalVisible,
  setIsModalVisible,
  setItemIdToDelete,
  handleConfirm,
  getConfirmMessage,
  getTitleMessage,
  actionType,

  // Import Manifest Entry Modal
  showImportManifestModal,
  setShowImportManifestModal,
  client,
  token,
  t,
  direction,
}) => (
  <>
    <ClientInactiveDialog
      open={openDialog}
      onClose={handleCloseDialog}
      t={t}
      handleActivateClient={handleActivateClient}
    />

    <DeleteUserDialog
      open={openDeleteDialog}
      onClose={handleCloseDeleteDialog}
      t={t}
      handleDeletePermanently={handleDeletePermanently}
      handleInactiveUser={handleInactiveUser}
    />

    <CustomDeleteConfirmationModal
      isVisible={isModalVisible}
      onClose={() => { setIsModalVisible(false); setItemIdToDelete(null); }}
      onDelete={handleConfirm}
      confirmMessage={getConfirmMessage()}
      titleMessage={getTitleMessage()}
      type={actionType}
    />

    {/* <ImportManifestEntryModal
      open={showImportManifestModal}
      onClose={() => setShowImportManifestModal(false)}
      direction={direction}
      t={t}
      client={client}
      token={token}
    /> */}
  </>
);

export default ModalsSection;
